// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import builderFetch
import { builderFetch } from '@automator/builder/utils';

/**
 * Adds a new loop to the current recipe
 *
 * @param {Object} iterableExpression Defines the default iterable expression of the loop
 * @param {("users"|"posts"|"token")} iterableExpression.type The elements that have to be iterated
 * @param {JSONString} [iterableExpression.fields] Only required if `.type` is "token", the fields
 * @param {JSONString} [iterableExpression.backup] Only required if `.type` is "token", the backup
 * @return {Promise} The apiFetch promise
 */
const createLoop = async ( iterableExpression ) => {
	// Event name
	const eventName = 'uap/builder/core/item/loop/create-loop';

	// If the item is not define, stop here
	if ( isEmpty( iterableExpression ) ) {
		throw new Error( `createLoop: The iterable expression must be defined` );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'add_loop_block',
			// eslint-disable-next-line camelcase
			iterable_expression: iterableExpression
		},
		snackbar: {
			loading: escapeHTML( __( 'Adding new loop', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Loop added successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					iterableExpression: iterableExpression
				}
			} ) );
		}

		return response;
	} );
}

export default createLoop;
